import { ref, Ref, computed } from 'vue';

export enum ErrorCode {
  USER_DOES_NOT_EXIST = 'USER_DOES_NOT_EXIST',
  USER_IS_MYWORLD_USER = 'USER_IS_MYWORLD_USER'
}

export enum ErrorType {
  InvalidCredentials = 1,
  ServiceUnavailable = 2,
  UnexpectedError = 3,
  UserDoesNotExist = 4,
  InvalidPasswordResetLink = 5,
  // error text is translated in the CxResetForm for that one
  PasswordsDoNotMatch = 6
}

export function useDisplayError(language: any) {
  // Data
  const currentErrorType: Ref<ErrorType | null> = ref(null);

  // Computed
  const errorTranslations = computed((): {
      invalidCredentials: string;
      serviceUnavailable: string;
      unexpectedError: string;
      userDoesNotExist: string;
      invalidPasswordResetLink: string;
    } => {
    return {
      invalidCredentials: language.$gettext('You have entered an invalid username and/or password'),
      serviceUnavailable: language.$gettext('Sorry, service is unavailable - please try again later'),
      unexpectedError: language.$gettext('Unexpected error has occurred - please try again later or contact support team'),
      userDoesNotExist: language.$gettext('Sorry, this user doesn\'t exist.'),
      invalidPasswordResetLink: language.$gettext('Sorry, this password reset link is invalid.'),
    };
  });

  const errorText = computed(() => {
    if (!currentErrorType.value) return null;
    if (currentErrorType.value === ErrorType.InvalidCredentials) return errorTranslations.value.invalidCredentials;
    if (currentErrorType.value === ErrorType.ServiceUnavailable) return errorTranslations.value.serviceUnavailable;
    if (currentErrorType.value === ErrorType.UnexpectedError) return errorTranslations.value.unexpectedError;
    if (currentErrorType.value === ErrorType.UserDoesNotExist) return errorTranslations.value.userDoesNotExist;
    if (currentErrorType.value === ErrorType.InvalidPasswordResetLink) return errorTranslations.value.invalidPasswordResetLink;
    return errorTranslations.value.unexpectedError;
  });

  return {
    currentErrorType,
    errorText
  };
}